import { useState } from "react"

import { useTranslation } from "react-i18next"

import { LibraryPicker } from "@/features/navigator/components/library-picker"

export function DemoCompanyLibraryModal() {
  const { t } = useTranslation("", { keyPrefix: "training.demo.libraries" })
  const [activeLibraryIds, setActiveLibraryIds] = useState<string[]>(["hr"])

  const mockLibraries = [
    { id: "hr", name: t("hr.name"), description: t("hr.description") },
    { id: "finance", name: t("finance.name"), description: t("finance.description") },
    { id: "it", name: t("it.name"), description: t("it.description") },
    { id: "legal", name: t("legal.name"), description: t("legal.description") },
    { id: "product", name: t("product.name"), description: t("product.description") },
  ]

  return (
    <div className="bg-card w-full rounded-lg border p-3 sm:max-w-xs">
      <LibraryPicker
        activeLibraryIds={activeLibraryIds}
        availableLibraries={mockLibraries}
        onActivationChange={setActiveLibraryIds}
      />
    </div>
  )
}
